document.addEventListener('DOMContentLoaded', function () {
  var slideshow = document.querySelector('.Slideshow__Carousel');
  if (!slideshow || typeof Flickity === 'undefined') return;

  var flkty = Flickity.data(slideshow);
  if (!flkty) return;

  var prevButton = document.querySelector('.Slideshow__NavButton--prev');
  var nextButton = document.querySelector('.Slideshow__NavButton--next');

  function updateNavButtonState() {
    var selectedIndex = flkty.selectedIndex;
    var slideCount = flkty.slides.length;

    if (prevButton) {
      prevButton.disabled = selectedIndex === 0;
      prevButton.classList.toggle('is-disabled', selectedIndex === 0);
    }

    if (nextButton) {
      nextButton.disabled = selectedIndex === slideCount - 1;
      nextButton.classList.toggle('is-disabled', selectedIndex === slideCount - 1);
    }
  }

  if (prevButton && nextButton) {
    prevButton.addEventListener('click', function () {
      flkty.previous();
    });

    nextButton.addEventListener('click', function () {
      flkty.next();
    });
  }

  // 初始化判断一次
  updateNavButtonState();

  // 每次切换时重新判断按钮状态
  flkty.on('select', updateNavButtonState);
});
    // m
var img0 = document.querySelector('.m_banner_pic_0'); // 选择第一个图片元素
var img1 = document.querySelector('.m_banner_pic_1'); // 选择第一个图片元素
// var img2 = document.querySelector('.m_banner_pic_2'); // 选择第一个图片元素


var srcValue0 = img0.getAttribute("data-src"); // 获取data-src属性的值
var srcValue1 = img1.getAttribute("data-src"); // 获取data-src属性的值
// var srcValue2 = img2.getAttribute("data-src"); // 获取data-src属性的值


console.log('第一张图片',srcValue0); // 输出 "image.jpg"
    var image0=new Image();
    var image1=new Image();
    // var image2=new Image();
    

    image0.src=srcValue0;
    image1.src=srcValue1;
    // image2.src=srcValue2;
   

    //图片加载完成事件 加载完成之后 将路径赋值给页面的图片
    image0.onload=function(){
      img0.src=this.src;
    }
    image1.onload=function(){
      img1.src=this.src;
    }
    if (document.querySelector(".m_banner_pic_2")) {
        var img2 = document.querySelector('.m_banner_pic_2'); // 选择第一个图片元素
        var srcValue2 = img2.getAttribute("data-src"); // 获取data-src属性的值
        var image2=new Image();
        image2.src=srcValue2;
        image2.onload=function(){
          img2.src=this.src;
        }
    }

    if (document.querySelector(".m_banner_pic_3")) {
        console.log("存在class为\"aaa\"的div元素");
        var img3 = document.querySelector('.m_banner_pic_3'); // 选择第一个图片元素
        var srcValue3 = img3.getAttribute("data-src"); // 获取data-src属性的值
        var image3=new Image();
        image3.src=srcValue3;
        image3.onload=function(){
          img3.src=this.src;
        }
    }
    if (document.querySelector(".m_banner_pic_4")) {
      var img4 = document.querySelector('.m_banner_pic_4'); // 选择第一个图片元素
      var srcValue4 = img4.getAttribute("data-src"); // 获取data-src属性的值
        var image4=new Image();
        image4.src=srcValue4;
        image4.onload=function(){
          img4.src=this.src;
        }
    }
    // pc
  var pc_img0 = document.querySelector('.pc_banner_pic_0'); // 选择第一个图片元素
  var pc_img1 = document.querySelector('.pc_banner_pic_1'); // 选择第一个图片元素
  // var pc_img2 = document.querySelector('.pc_banner_pic_2'); // 选择第一个图片元素

  var pc_srcValue0 = pc_img0.getAttribute("data-src"); // 获取data-src属性的值
  var pc_srcValue1 = pc_img1.getAttribute("data-src"); // 获取data-src属性的值
  // var pc_srcValue2 = pc_img2.getAttribute("data-src"); // 获取data-src属性的值


    var pc_image0=new Image();
    var pc_image1=new Image();
    // var pc_image2=new Image();


    pc_image0.src=pc_srcValue0;
    pc_image1.src=pc_srcValue1;
    // pc_image2.src=pc_srcValue2;


    //图片加载完成事件 加载完成之后 将路径赋值给页面的图片
    pc_image0.onload=function(){
      pc_img0.src=this.src;
    }
    pc_image1.onload=function(){
      pc_img1.src=this.src;
    }
    if (document.querySelector(".pc_banner_pic_2")) {
      var pc_img2 = document.querySelector('.pc_banner_pic_2'); // 选择第一个图片元素
      var pc_srcValue2 = pc_img2.getAttribute("data-src"); // 获取data-src属性的值
      var pc_image2=new Image();
      pc_image2.src=pc_srcValue2;
      pc_image2.onload=function(){
        pc_img2.src=this.src;
      }
    }
    
  if (document.querySelector(".pc_banner_pic_3")) {
      var pc_img3 = document.querySelector('.pc_banner_pic_3'); // 选择第一个图片元素
      var pc_srcValue3 = pc_img3.getAttribute("data-src"); // 获取data-src属性的值
      var pc_image3=new Image();
      pc_image3.src=pc_srcValue3;
      pc_image3.onload=function(){
        pc_img3.src=this.src;
      }
  }
  if (document.querySelector(".pc_banner_pic_4")) {
      var pc_img4 = document.querySelector('.pc_banner_pic_4'); // 选择第一个图片元素
      var pc_srcValue4 = pc_img4.getAttribute("data-src"); // 获取data-src属性的值
      var pc_image4=new Image();
      pc_image4.src=pc_srcValue4;
      pc_image4.onload=function(){
        pc_img4.src=this.src;
      }
  }
